import { render, staticRenderFns } from "./IotAlertWhitelistModal.vue?vue&type=template&id=4c856c50&"
import script from "./IotAlertWhitelistModal.vue?vue&type=script&lang=js&"
export * from "./IotAlertWhitelistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports